export default "__VITE_ASSET__Bvw6rfvW__"